export const authenticatedRoutes = {
  Communications: '/account/communications',
  Documents: '/account/documents',
  Help: '/account/help',
  Invest: '/account/invest',
  Overview: '/account/overview',
  Settings: '/account/settings',
  Wallet: '/account/wallet',
};

export const unauthenticatedRoutes = {
  Auth: '/auth',
  root: '/',
};

export const AppRoutes = {
  ...authenticatedRoutes,
  ...unauthenticatedRoutes,
};
